import { 
    HrReportsTypes,
    UPDATE_REPORTS,
    UPDATE_PROGRESS,
    HrReportsState,
    TOGGLE_HINT,
    ADD_REPORT,
    POPULATE_REPORTS,
    DELETE_REPORT,
    TOGGLE_CONTEXT
} from "./types";

const initialState: HrReportsState = {
    selectedItems : [],
    updating : false,
    showHint : false,
    reports : {

    },
    totalReports : 0,
    contextOpen: true,
}

export function hrReportsReducer(
    state = initialState,
    action: HrReportsTypes
):HrReportsState {
    switch(action.type){
        case POPULATE_REPORTS:
            return {...state, reports : {...action.payload}}
        case UPDATE_REPORTS:
            return {...state, updating : false, selectedItems : action.payload};
        case UPDATE_PROGRESS:
            return {...state, updating : action.payload};
        case TOGGLE_HINT:
            return {...state, showHint : action.payload};
        case ADD_REPORT:
            let reportsCopy: any = {...state.reports};
            reportsCopy[action.payload.name] = {
                type : action.payload.type,
                data : action.payload.data
            };
            return {
                ...state, 
                reports : reportsCopy, 
                totalReports : state.totalReports + 1
            };
        case DELETE_REPORT:
            let reports: any = {...state.reports};
            delete reports[action.payload];
            return {...state, reports, totalReports : state.totalReports - 1}
        case TOGGLE_CONTEXT:
            return { ...state, contextOpen: !state.contextOpen }
        default:
            return state;
    }
}
